import { render, staticRenderFns } from "./AddClientOrder.vue?vue&type=template&id=8bb04854&scoped=true"
import script from "./AddClientOrder.vue?vue&type=script&lang=js"
export * from "./AddClientOrder.vue?vue&type=script&lang=js"
import style0 from "./AddClientOrder.vue?vue&type=style&index=0&id=8bb04854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb04854",
  null
  
)

export default component.exports